import { EMenuType } from 'shared/components/AppSidebarV2';

/**
 * Default sidebar configuration.
 */
export const DefaultSidebar: any[] = [
    {
        path: '/dashboard',
        title: 'Dashboard',
        icon: <img src="#" alt="icon" />,
        key: 'dashboard',
        navigationType: EMenuType.NAVIGATION,
        superFlag: null,
    },
    {
        path: '/upload-cross-checks',
        title: 'Upload Cross Checks',
        icon: <img src="#" alt="icon" />,
        key: 'upload-cross-checks',
        navigationType: EMenuType.NAVIGATION,
        superFlag: null,
    },
    {
        path: '/manage-cross-checks',
        title: 'Manage Cross Checks',
        icon: <img src="#" alt="icon" />,
        key: 'manage-cross-checks',
        navigationType: EMenuType.NAVIGATION,
        superFlag: null,
        childrenPath: [
            '/single-cross-checks',
            '/not-expected-cross-check',
            '/loanwriter',
            '/single-reviewed',
        ],
    },
    {
        path: '/manage-checklists',
        title: 'Checklists',
        icon: <img src="#" alt="icon" />,
        key: 'manage-checklists',
        navigationType: EMenuType.NAVIGATION,
        superFlag: null,
    },
    {
        path: '/manage-access',
        title: 'Access Management',
        icon: <img src="#" alt="icon" />,
        key: 'manage-access',
        navigationType: EMenuType.NAVIGATION,
        superFlag: null,
    },
    // {
    //     path: '/faq',
    //     title: 'FAQ',
    //     icon: <img src="#" alt="icon" />,
    //     key: 'faq',
    //     navigationType: EMenuType.NAVIGATION,
    //     superFlag: null,
    // },
];
